import React, { useEffect } from "react";

import { useState } from "react";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { RadioGroup, RadioGroupItem } from "../../components/ui/radio-group";
import { Checkbox } from "../../components/ui/checkbox";
import { Badge } from "../../components/ui/badge";
import { Star, Save, X } from "lucide-react";
import PropTypes from "prop-types";
import "../../components/submission-editor.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Alert, Snackbar } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export default function EditForm() {
  const navigate = useNavigate();
  const { id, created_by, submission_id } = useParams();

  const [editingSubmission, setEditingSubmission] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({});
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});
  const [state, setState] = useState({
    open: false,
    severity: "success",
    vertical: "top",
    horizontal: "right",
    message: "",
  });

  const handleClose = () => setState({ ...state, open: false });
  const me = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    // console.log("🚀 ~ fetchUsers ~ response:", response);
    return response.data;
  };

  const {
    data: meData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["me"], // Unique key for the query
    queryFn: me, // The async function to run
    retry: false,
  });

  useEffect(() => {
    const fetchFormById = async () => {
      // console.log("🚀 ~ FillForm ~ meData:", meData);
      //   if ((viewMode === "fill" || viewMode === "preview") && selectedForm) {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/forms/${id}`, {
          withCredentials: true,
        });
        // console.log("🚀 ~ fetchFormById ~ res:", res.data.data);
        // if (viewMode === "fill") {
        const form = res.data.data;
        // debugger
        setForm(form);
        // setFormData(() => {
        //   const initialData = {};
        //   //   debugger;
        //   form.fields?.forEach((field) => {
        //     if (field.type === "select" && field.id === "field_months") {
        //       initialData[field.id] = new Date().toLocaleString("default", { month: "long" });
        //     } else {
        //       initialData[field.id] = "";
        //     }
        //   });
        //   return initialData;
        // });
      } catch (err) {
        console.error("Error fetching form by ID:", err);
      }
    };
    // };

    fetchFormById();
  }, [id, meData]);

  useEffect(() => {
    const fetchSubmission = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/submissions/${id}`, {
          params: { created_by, submission_id },
          withCredentials: true,
        });

        // console.log("Response:", response);

        const result = response.data;

        if (result.status === 200) {
          const formDataResponse = result.data; // <-- unwrap the `data` object
          const submission = Array.isArray(formDataResponse.submissions)
            ? formDataResponse.submissions[0]
            : formDataResponse.submissions;

          setEditingSubmission({
            form: formDataResponse,
            submission,
          });

          setFormData(() => {
            const initialData = {};
            formDataResponse.fields.forEach((field) => {
              // initialData[field.id] = submission?.[field.id] || "";
              let fieldValue = submission?.[field.id] || "";
              if (field.type === "checkbox") {
                try {
                  fieldValue = fieldValue ? JSON.parse(fieldValue) : [];
                } catch (err) {
                  fieldValue = [];
                }
              }
              initialData[field.id] = fieldValue;
            });
            return initialData;
          });
        } else {
          console.error("Failed to fetch submission");
        }
      } catch (error) {
        console.error("Error fetching submission:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id && created_by && submission_id) {
      fetchSubmission();
    }
  }, [id, created_by, submission_id]);

  const formatDateForMySQL = (isoDate) => {
    const d = new Date(isoDate);
    return d.toISOString().slice(0, 19).replace("T", " ");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form) return; // safety check

    const newErrors = {};

    form.fields.forEach((field) => {
      let value = formData[field.id];

      // For rating fields, default to 0 if empty
      if (field.type === "rating") {
        value = value || 0;
      }

      const error = validateField(field, value);
      if (error) {
        newErrors[field.id] = error;
      }
    });

    setErrors(newErrors);

    // If there are no errors, submit the form
    if (Object.keys(newErrors).length === 0) {
      handleFormSubmission(id, editingSubmission?.submission, formData);
    }
  };

  const handleFormSubmission = async (formId, submissionData, formData) => {
    // debugger;
    const payload = {
      form: {
        id: form.id,
        title: form.title,
        description: form.description,
        createdAt: formatDateForMySQL(form.createdAt),
        created_by: form.created_by,
        fields: form.fields, // ✅ only fields, no submissions
      },
      submission: {
        submission_id,
        ...submissionData, // original submission values
        ...formData, // updated field values
        updatedAt: new Date().toISOString(),
        updated_by: meData?.user_id,
        district: meData?.district,
      },
    };

    try {
      setLoading(true);
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/submissions/update`, payload, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      // console.log("resres", res);

      if (res.data.status === 200) {
        setState({
          ...state,
          open: true,
          severity: "success",
          message: res.data.message, // ✅ Correct path
        });
        setTimeout(() => {
          if (meData?.role_id === 3) {
            navigate("/tasks-management");
          } else {
            navigate("/form-builder");
          }
        }, 3000);
      }
    } catch (err) {
      console.error("❌ Error updating form:", err);

      if (err.response) {
        setState({
          ...state,
          open: true,
          severity: "error",
          message: err.response.data.message || "Failed to update form",
        });
      } else {
        setState({
          ...state,
          open: true,
          severity: "error",
          message: "Server error. Please try again.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const renderField = (field) => {
    const value = formData[field.id] || "";

    switch (field.type) {
      case "textarea":
        return (
          <Textarea
            value={value}
            onChange={(e) => handleFieldChange(field.id, e.target.value)}
            placeholder={field.placeholder}
            className="submission-input"
          />
        );

      case "select":
        return (
          <Select value={value} onValueChange={(val) => handleFieldChange(field.id, val)}>
            <SelectTrigger className="submission-select">
              <SelectValue placeholder={field.placeholder || "Select an option"} />
            </SelectTrigger>
            <SelectContent className="submission-select-dropdown">
              {field.options?.map((option, index) => (
                <SelectItem key={index} value={option} className="submission-select-item">
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        );

      case "radio":
        return (
          <RadioGroup value={value} onValueChange={(val) => handleFieldChange(field.id, val)}>
            {field.options?.map((option, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "6px", // spacing between each option
                  minHeight: "28px", // makes row slightly taller
                }}
              >
                <RadioGroupItem value={option} id={`${field.id}-${index}`} />
                <Label htmlFor={`${field.id}-${index}`} className="submission-radio-item">
                  {option}
                </Label>
              </div>
            ))}
          </RadioGroup>
        );

      case "checkbox":
        const checkboxValues = Array.isArray(value) ? value : [];
        return (
          <div className="submission-radio-group">
            {field.options?.map((option, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "6px", // spacing between each option
                  minHeight: "28px", // makes row slightly taller
                }}
              >
                <Checkbox
                  id={`${field.id}-${index}`}
                  checked={checkboxValues.includes(option)}
                  onCheckedChange={(checked) => {
                    if (checked) {
                      handleFieldChange(field.id, [...checkboxValues, option]);
                    } else {
                      handleFieldChange(
                        field.id,
                        checkboxValues.filter((v) => v !== option)
                      );
                    }
                  }}
                />
                <Label htmlFor={`${field.id}-${index}`} className="submission-radio-item">
                  {option}
                </Label>
              </div>
            ))}
          </div>
        );

      case "rating":
        return (
          <div className="submission-rating">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                className={`submission-rating-star ${star <= (value || 0) ? "active" : ""}`}
                onClick={() => handleFieldChange(field.id, star)}
              />
            ))}
          </div>
        );

      default:
        return (
          <Input
            type={field.type}
            value={value}
            onChange={(e) => handleFieldChange(field.id, e.target.value)}
            placeholder={field.placeholder}
            className="submission-input"
          />
        );
    }
  };

  const handleFieldChange = (fieldId, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldId]: value,
    }));
  };

  const handleCancel = () => {
    navigate("/tasks-management");
  };

  const validateField = (field, value) => {
    if (field.required && (!value || (Array.isArray(value) && value.length === 0))) {
      return `${field.label} is required`;
    }

    if (field.validation) {
      if (field.validation.minLength && value && value.length < field.validation.minLength) {
        return `${field.label} must be at least ${field.validation.minLength} characters`;
      }
      if (field.validation.maxLength && value && value.length > field.validation.maxLength) {
        return `${field.label} must be no more than ${field.validation.maxLength} characters`;
      }
    }

    if (field.type === "email" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Please enter a valid email address";
    }

    if (field.type === "phone" && value && !/^[+]?[1-9][\d]{0,9}$/.test(value.replace(/\s/g, ""))) {
      return "Please enter a valid phone number";
    }

    return null;
  };

  return (
    <DashboardLayout>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={state.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity={state.severity} variant="filled">
          {state.message}
        </Alert>
      </Snackbar>
      <div style={{ marginBottom: "20px" }}>
        <Button
          onClick={() => navigate("/tasks-management")}
          style={{
            backgroundColor: "#006400",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#004d00")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#006400")}
        >
          ← Back to Forms
        </Button>
      </div>
      <Card className="submission-renderer-card">
        <CardHeader className="submission-renderer-header">
          <CardTitle className="submission-renderer-title">
            <Save className="icon" />
            Edit Submission
          </CardTitle>
          <CardDescription className="submission-renderer-desc">
            Modify the submitted data for &quot;{form?.title}&quot;
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {form?.fields?.map((field) => (
              <div key={field.id} className="submission-field">
                <Label htmlFor={field.id} className="submission-label">
                  {field.label}
                  {field.required && <span className="submission-required">*</span>}
                </Label>
                {renderField(field)}

                {errors[field.id] && (
                  <p className="form-error" style={{ color: "red", marginTop: "4px" }}>
                    {errors[field.id]}
                  </p>
                )}
              </div>
            ))}
          </div>

          <div className="flex gap-2 pt-4">
            <Button
              disabled={loading}
              // onClick={() => handleFormSubmission(id, formData)}
              onClick={handleSubmit}
              className="btn btn-primary submission-submit"
            >
              <Save className="icon" />
              Save Changes
            </Button>
            <Button
              variant="outline"
              onClick={handleCancel}
              className="btn btn-danger submission-submit"
            >
              <X className="icon" />
              Cancel
            </Button>
          </div>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
